"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Assert = _interopRequireDefault(require("../util/Assert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SegmentPointComparator =
/*#__PURE__*/
function () {
  function SegmentPointComparator() {
    _classCallCheck(this, SegmentPointComparator);

    SegmentPointComparator.constructor_.apply(this, arguments);
  }

  _createClass(SegmentPointComparator, [{
    key: "getClass",
    value: function getClass() {
      return SegmentPointComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "relativeSign",
    value: function relativeSign(x0, x1) {
      if (x0 < x1) return -1;
      if (x0 > x1) return 1;
      return 0;
    }
  }, {
    key: "compare",
    value: function compare(octant, p0, p1) {
      if (p0.equals2D(p1)) return 0;
      var xSign = SegmentPointComparator.relativeSign(p0.x, p1.x);
      var ySign = SegmentPointComparator.relativeSign(p0.y, p1.y);

      switch (octant) {
        case 0:
          return SegmentPointComparator.compareValue(xSign, ySign);

        case 1:
          return SegmentPointComparator.compareValue(ySign, xSign);

        case 2:
          return SegmentPointComparator.compareValue(ySign, -xSign);

        case 3:
          return SegmentPointComparator.compareValue(-xSign, ySign);

        case 4:
          return SegmentPointComparator.compareValue(-xSign, -ySign);

        case 5:
          return SegmentPointComparator.compareValue(-ySign, -xSign);

        case 6:
          return SegmentPointComparator.compareValue(-ySign, xSign);

        case 7:
          return SegmentPointComparator.compareValue(xSign, -ySign);
      }

      _Assert.default.shouldNeverReachHere("invalid octant value");

      return 0;
    }
  }, {
    key: "compareValue",
    value: function compareValue(compareSign0, compareSign1) {
      if (compareSign0 < 0) return -1;
      if (compareSign0 > 0) return 1;
      if (compareSign1 < 0) return -1;
      if (compareSign1 > 0) return 1;
      return 0;
    }
  }]);

  return SegmentPointComparator;
}();

exports.default = SegmentPointComparator;

SegmentPointComparator.constructor_ = function () {};